<template>
    <a-modal :title="form.id ? '编辑额外费用' : '添加额外费用'" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
        @cancel="handleCancel">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item label="费用名称" prop="title">
                <a-input v-model="form.title" placeholder="请输入费用名称（手续费等）" />
            </a-form-model-item>
            <a-form-model-item label="费用金额" prop="price">
                <a-input-number v-model="form.price" :step="0.01" :precision="2" style="width: 100%"
                    placeholder="请输入费用金额" />
            </a-form-model-item>
            <a-form-model-item label="费用备注" prop="remark">
                <a-input v-model="form.remark" placeholder="请输入费用备注" />
            </a-form-model-item>
        </a-form-model>
        <a-alert message="额外费用金额将算进利润中，如金额是'负数', 则会从利润中减去，如金额是'正数', 则会从利润中加上" banner>
        </a-alert>
    </a-modal>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            confirmLoading: false,
            form: {
                id: '',
                title: '',
                price: '',
                remark: ''
            },
            rules: {
                title: { required: true, message: '请输入费用名称', trigger: 'blur' },
                price: { required: true, message: '请输入费用金额', trigger: 'blur' },
            }
        };
    },
    methods: {
        init(row) {
            this.visible = true;
            this.form.tripproject_id = row.tripproject_id
            if (row.id) {
                this.form.id = row.id
                this.$http({
                    url: '/admin/tripextracosts/info',
                    method: 'post',
                    data: {
                        id: this.form.id
                    }
                }).then(res => {
                    this.form = res.data
                })
            }
        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$http({
                        url: this.form.id ? '/admin/tripextracosts/update' : '/admin/tripextracosts/create',
                        method: 'post',
                        data: this.form
                    }).then(() => {
                        this.$message.success(this.form.id ? '修改成功' : '添加成功')
                        this.$emit('ok')
                        this.handleCancel()
                    }).finally(() => {
                        this.confirmLoading = false;
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.visible = false;
            this.$refs.ruleForm.resetFields();
            this.form.id = ""
        },
    },
};
</script>